import { cn } from "@reactive-resume/utils";

type IframeHeaderProps = {
  title: string;
  className: string;
  btnLabel: string;
  loadingLabel: string;
  isLoading: boolean;
  onClick: () => void;
  Icon: React.FC<any>;
};

export const IframeHeader = ({
  title,
  className,
  onClick,
  isLoading,
  loadingLabel,
  btnLabel,
  Icon,
}: IframeHeaderProps) => {
  return (
    <div className="relative flex items-center justify-center bg-green-50 p-4 dark:bg-green-900/40">
      <span className="text-primary dark:text-primary text-lg font-semibold">{title}</span>
      <button
        onClick={onClick}
        disabled={isLoading}
        className={cn(
          "absolute right-3 flex cursor-pointer items-center justify-center gap-1.5 rounded-lg px-3 py-2 text-xs font-medium text-white shadow-md transition-all duration-200 ease-out hover:scale-105 hover:bg-red-600 hover:shadow-lg focus:ring-2 focus:ring-red-500/50 focus:ring-offset-1 active:scale-95 disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-70 disabled:hover:scale-100",
          className,
        )}
        aria-label="Reject optimization"
      >
        {isLoading ? (
          <>
            <div className="h-3 w-3 animate-spin rounded-full border-2 border-white border-r-transparent" />
            {loadingLabel}
          </>
        ) : (
          <>
            <Icon size={14} weight="bold" />
            {btnLabel}
          </>
        )}
      </button>
    </div>
  );
};
